<script>
import { get as _get } from 'lodash'
import { APP_CHANNEL } from '@/common/utils/variables.js'
import { CONTRAST_ID } from 'pages/planbkTemplate/base/config.js'
import Banner from './banner'

export default {
  name: 'ResultBanner',
  components: {
    Banner
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tmpData: {
      type: Object,
      default: () => ({})
    },
    themeSettings: {
      type: Object,
      default: () => ({
        defaultTheme: '',
        previewTheme: ''
      })
    },
    themeList: {
      type: Array,
      default: () => []
    },
    card: {
      type: Object,
      default () {
        return {}
      }
    },
    token: [String, Object],
    uuid: {
      type: String,
      default: ''
    },
    isForPresentation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowBanner () {
      return this.title && !['H5_BXZ'].includes(APP_CHANNEL)
    },
    // 对比计划书->计划书详情
    isContrastPb () {
      const {
        tmpData: { resultData }
      } = this
      return resultData.insuranceTypeId == CONTRAST_ID
    },
    insuranceInfor () {
      return this.tmpData.insuranceType
    },
    personalizedBanner () {
      return this.insuranceInfor && this.insuranceInfor.pbResultBannerV2
    },
    // 优先使用 themeList 中当前主题的 banner（含链接带 theme 或弹窗中切换同主题）；无再用 resultData.insuranceType 的 pbResultBannerV2/pbRestBannUrl
    bannerUrlAndLabelPosition () {
      const { themeSettings, themeList, personalizedBanner, isContrastPb } = this;
      const { defaultTheme, previewTheme } = themeSettings
      const themeItem = (themeList || []).find(it => it.key === previewTheme) || (themeList || []).find(it => it.key === 'healthy')
      const themeBannerUrl = themeItem ? (_get(themeItem, 'bannerImage') || null) : null
      if (themeBannerUrl) {
        return {
          banner: themeBannerUrl,
          bannerNameBg: _get(themeItem, 'bannerNameBg') || null,
          labelPosition: isContrastPb ? 'none' : 'bottom',
          bannerContainerClassName: 'theme-banner'
        }
      }
      const isUsePersonalizedBanner = previewTheme === defaultTheme && personalizedBanner
      if (isUsePersonalizedBanner) {
        const personalizedBannerIndicatesLabel = personalizedBanner && personalizedBanner.includes('common_bn')
        return {
          banner: personalizedBanner,
          labelPosition: personalizedBannerIndicatesLabel ? 'legacy' : 'none',
          bannerContainerClassName: 'legacy-theme-banner'
        }
      }
      return {
        banner: themeBannerUrl,
        bannerNameBg: _get(themeItem, 'bannerNameBg') || null,
        labelPosition: isContrastPb ? 'none' : 'bottom',
        bannerContainerClassName: 'theme-banner'
      }
    }
  },
  methods: {
    childMounted () {
      this.$emit('done')
    }
  }
}
</script>
<template>
  <banner
    v-if="isShowBanner"
    :class="bannerUrlAndLabelPosition.bannerContainerClassName"
    :title="title"
    :head-banner="bannerUrlAndLabelPosition.banner"
    :insurance-infor="insuranceInfor"
    :insurance-label-position="bannerUrlAndLabelPosition.labelPosition"
    :banner-name-bg="bannerUrlAndLabelPosition.bannerNameBg"
    @hook:mounted="childMounted"
  />
</template>
<style lang="postcss">
.legacy-theme-banner {
  margin-bottom: -23px;
}
.theme-banner {
  margin-bottom: 8px;
}
</style>


